import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { ProgressBar } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import VerbHeading from '../../shared/components/VerbHeading';
import VerbText from '../../shared/components/VerbText';

const ComparisonBar = (props) => {
    const {
        className,
        dividend = 0,
        divisor = 0,
        dividendLabelTextId = ' ',
        divisorLabelTextId = ' ',
        isVisible = false,
        headingTextId,
        headingDefaultMessage,
        labelString = null
    } = props;

    let now;
    if (dividend >= divisor) {
        now = Math.floor((divisor / dividend) * 100);
    }
    if (!dividend || !divisor) {
        now = 0;
    }
    if (dividend < divisor) {
        now = 100;
    }

    if (!isVisible) {
        return null;
    }
    const dividendLabel = <VerbText messageId={dividendLabelTextId} />;
    const divisorLabel = <VerbText messageId={divisorLabelTextId} />;

    return (
        <div className={cns('comparisonBar', 'col-sm-12', className)}>
            <div className={'col-sm-12'}>
                <VerbHeading hNumber={6} messageId={headingTextId} defaultMessage={headingDefaultMessage} />
            </div>
            <div className={'col-sm-12 comparisonBarProgress'}>
                <div className={'col-sm-12 comparisonBarProgressWrap'}>
                    <ProgressBar now={now} />
                </div>
            </div>
            {labelString && <div className={'col-sm-12 comparisonBarDividend'}>{labelString}</div>}
            {!labelString && (
                <div className={'col-sm-12 comparisonBarDividend'}>
                    {dividendLabel}
                    <span>: </span> {dividend} <span> | </span> {divisorLabel}
                    <span>: </span> {divisor}
                </div>
            )}
        </div>
    );
};

ComparisonBar.propTypes = {
    className: PropTypes.string,
    dividend: PropTypes.number,
    divisor: PropTypes.number,
    isVisible: PropTypes.bool,
    headingTextId: PropTypes.string,
    dividendLabelTextId: PropTypes.string,
    divisorLabelTextId: PropTypes.string,
    headingDefaultMessage: PropTypes.string,
    labelString: PropTypes.string
};

export default injectIntl(ComparisonBar);
